import React, { FC } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Button } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { APPLICATION_DETAIL } from "../Routes";

const ViewAppDetailButton: FC<CustomCellRendererProps> = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => {
        navigate(`${APPLICATION_DETAIL}/${data.id}`);
      }}
      variant="text"
      startIcon={<RemoveRedEyeIcon />}
    >
      View more...
    </Button>
  );
};

export default ViewAppDetailButton;
